import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { OperatorShiftAssignmentComponent } from './features/operator-shift-assignment/operator-shift-assignment.component';
import { DetailOperatorComponent } from './features/operator-shift-assignment/components/detail-operator/detail-operator.component';

export const routes: Routes = [
  {
    path:'',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path:'registration',
    loadComponent: () => import('./features/registration/registration.component').then((c) => c.RegistrationComponent), 
  },
  {
    path:'login',
    loadComponent: () => import('./features/login/login.component').then((c) => c.LoginComponent), 
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./features/dashboard/dashboard.component').then((c) => c.DashboardComponent), 
    data: { breadcrumb: 'Dashboard' },
  },
  {
    path: 'bookings',
    loadComponent: () =>import('./features/reservations/my-reservations.component').then((c) => c.ReservationsComponent),
    data: { breadcrumb: 'Prenotazione' },
  },
  {
    path: 'management-structure',
    loadComponent: () =>import('./features/structure-registration/structure-registration.component').then((c) => c.StructureRegistrationComponent),
    data: { breadcrumb: 'Gestione struttura' },
  },
  {
    path: 'summary-bookings',
    loadComponent: () =>import('./features/summary-bookings/summary-bookings.component').then((c) => c.SummaryComponent),
    data: { breadcrumb: 'Riepilogo prenotazioni' },

  },
  {
    path: 'day-bookings',
    loadComponent: () =>import('./features/summary-day-bookings/summary-day-bookings.component').then((c) => c.SummaryDayBookingsComponent),
    data: { breadcrumb: 'Riepilogo giornaliero delle prenotazioni' },
  },
  {
    path:'operator-shifts',
    loadComponent: () => import('./features/operator-shift-assignment/operator-shift-assignment.component').then((c) =>OperatorShiftAssignmentComponent),
    data: { breadcrumb: "Assegnazione turni dell'operatore" },
    // children:[
    //     {
    //         path:'detail-operator/:id',
    //         loadComponent: () => import('./features/operator-shift-assignment/components/detail-operator-dialog/detail-operator.component').then((c) =>DetailOperatorComponent),
    //         data: { breadcrumb: "Assegnazione turni dell'operatore" },
    //     },
    // ]
  },
  {
    path: 'operator-shifts/detail-operator/:id',
    loadComponent: () => import('./features/operator-shift-assignment/components/detail-operator/detail-operator.component').then(c => DetailOperatorComponent),
    data: { breadcrumb: "Dettaglio operatore" }
  },
  {
    path:'**',
    component:LoginComponent
  },
];
